import React from 'react';
import { Helmet } from 'react-helmet';

const ContactUs = () => {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", lineHeight: '1.6', color: '#333', background: '#f5f5f5', minHeight: '100vh' }}>
      <Helmet>
        <title>Contact SugarHathi — Villgrains FarmTech Pvt Ltd</title>
        <meta name="description" content="Get in touch with SugarHathi for sugar trading, quota data, or platform support." />
      </Helmet>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', background: 'white', minHeight: '100vh' }}>

        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '3px solid #2ecc71' }}>
          <h1 style={{ fontSize: '2.5rem', color: '#2ecc71', margin: '0 0 10px 0', padding: 0 }}>Contact Us</h1>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: 0 }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
        </div>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>Get in Touch</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            For any queries, support requests, or business inquiries, reach us through any of the following channels.
            We aim to respond within 1 business day.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>Contact Details</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Company:</strong> Villgrains FarmTech Private Limited</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Trading As:</strong> SugarHathi</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>WhatsApp:</strong> +91 79899 53468</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Website:</strong> www.sugarhathi.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>Address:</strong> 101B, Vishnu Acharya Nivas, Road No 3, Journalist Colony, Banjara Hills, Hyderabad, Telangana - 500034</p>
          </div>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>Grievance Officer</h2>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Name:</strong> KK Mena</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Designation:</strong> Founder</p>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>Response Time:</strong> Within 30 days</p>
          </div>
        </section>

        <div style={{ textAlign: 'center', marginTop: '50px', paddingTop: '30px', borderTop: '2px solid #e0e0e0', color: '#666', fontSize: '0.9rem' }}>
          <p style={{ marginBottom: '5px' }}>&copy; 2026 Villgrains FarmTech Private Limited. All rights reserved.</p>
          <p style={{ margin: 0 }}>Trading as SugarHathi</p>
        </div>

      </div>
    </div>
  );
};

export default ContactUs;
